import axios from 'axios'
// import MockAdapter from 'axios-mock-adapter'
import injector from 'vue-inject'
import router from '../router'
import menu from './menu'

const axiosPureInstance = axios.create()

const axiosInstance = axios.create()
axiosInstance.defaults.baseURL = `${process.env.VUE_APP_API_URL}`
axiosInstance.interceptors.response.use((response) => {
  return response
}, error => {
  const { response: { status } } = error
  if (status === 401) {
    router.push('/system/login')
    axios.defaults.headers.common.Authorization = null
    return Promise.reject(error)
  } else {
    return Promise.reject(error)
  }
})

/*
const apiUrl = 'http://localhost:3000/api/v1'

const mock = new MockAdapter(axiosInstance, { delayResponse: 1000 })
mock.onPost(`${apiUrl}/auth/signin`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJtdmVnYXAiLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE1NzU2NTM3MTZ9.LaCS0Fq6BftL60tU7d-obKCJ2gigFXm9csc9iTosUgk',
  }]
})

mock.onGet(`${apiUrl}/users/1/roles`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: [
      {
        id: 4,
        idUser: 1,
        idRole: 1,
        createdAt: '2019-12-06T16:37:13.000Z',
        updatedAt: '2019-12-06T16:37:13.000Z',
        Role: {
          id: 1,
          name: 'ROLE_ADMIN',
          description: '',
          stateId: 1,
        },
      },
    ],
  }]
})

mock.onGet(`${apiUrl}/users/1/modules`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: [
      {
        id: 1,
        idUser: 1,
        idModule: 1,
        createdAt: '2019-12-06T15:37:20.000Z',
        updatedAt: '2019-12-06T15:37:20.000Z',
        Module: {
          id: 1,
          name: 'Bancomercio',
          description: '',
          path: 'https://api.kontigo.pe',
          stateId: 1,
        },
      },
      {
        id: 5,
        idUser: 1,
        idModule: 1,
        createdAt: '2019-12-06T15:37:20.000Z',
        updatedAt: '2019-12-06T15:37:20.000Z',
        Module: {
          id: 1,
          name: 'Caja Arequipa Premium',
          description: '',
          path: 'https://sandbox.cajaarequipa.com.pe',
          stateId: 1,
        },
      },
      {
        id: 6,
        idUser: 1,
        idModule: 2,
        createdAt: '2019-12-06T15:37:20.000Z',
        updatedAt: '2019-12-06T15:37:20.000Z',
        Module: {
          id: 2,
          name: 'BBVA Continental',
          description: '',
          path: 'https://182.631.156.100:3000/api/v1',
          stateId: 1,
        },
      },
      {
        id: 7,
        idUser: 1,
        idModule: 3,
        createdAt: '2019-12-06T15:37:20.000Z',
        updatedAt: '2019-12-06T15:37:20.000Z',
        Module: {
          id: 3,
          name: 'CrediPlaza',
          description: '',
          path: 'https://api.crediplaza.com.pe',
          stateId: 1,
        },
      },
    ],
  }]
})

mock.onGet(`${apiUrl}/maintenance/modules/1/endpoints`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: [
      {
        id: 1,
        idModule: 1,
        slug: '/dashboard/download?listId=1001&effectiveStartDate=2020-01-11&effectiveEndDate=2020-01-11&entity=bancomercio&group_states=null',
        createdAt: '2019-12-06T15:36:30.000Z',
        updatedAt: '2019-12-06T15:36:30.000Z',
        deletedAt: null,
        version: 0,
      },
    ],
  }]
})

mock.onGet(`${apiUrl}/maintenance/modules/list-all`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: [
      {
        id: 1,
        name: 'Bancomercio',
        description: '',
        path: 'https://api.kontigo.pe',
        stateId: 1,
      },
      {
        id: 2,
        name: 'BBVA Continental',
        description: '',
        path: 'https://182.631.156.100:3000/api/v1',
        stateId: 1,
      },
      {
        id: 3,
        name: 'CrediPlaza',
        description: '',
        path: 'https://api.crediplaza.com.pe',
        stateId: 1,
      },
      {
        id: 4,
        name: 'Caja Arequipa Premium',
        description: '',
        path: 'https://sandbox.cajaarequipa.com.pe',
        stateId: 1,
      },
    ],
  }]
})

mock.onGet(`${apiUrl}/admin/users/list-all`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: [
      {
        id: 1,
        firstName: 'Miguel',
        lastName: 'Vega',
        email: 'miguelv.ter@kontigo.pe',
        username: 'mvegap',
        password: '$argon2i$v=19$m=4096,t=3,p=1$q9GmHJX8TiiwYPSi9k3EkA$bZdhiGCoN0BPrrluU2XPwrbhQl+DvcRa7GbigEBhj4Q',
        stateId: 1,
        token: null,
        lastLoginAccess: '2019-12-06T17:35:16.000Z',
        lastLogoutAccess: null,
        lastIpAddress: '::1',
        lastToken: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im12ZWdhcCIsInJvbCI6bnVsbCwiaWF0IjoxNTc1NjUzNzE2fQ.XAu7_XuQ6q00SfD96GkbVS6nEQVKRqbf7lFKRrFubjrN4Xvss4QLO15tYFwxhm0wQVn8OW7xoxQ88KChDjae0Z7OSMM_0kiyMUghQtMHmQiSqdBThhzHW8lm8uf90-FDj5sbELgCvvhL8jXWysnFowNyLHEiOaS29JQWYLJTxuBj3HL9sVs6W0l2yso5KmY84SZy3cz8KgFZfUfMh0ucXXo1rSiYCeQAtWRZhq8H2sEkuWAEG8zesHTOY1DZ-E8DjLDQLU4vJ9POQDWzxCXQxfc4d0i_jroAPdcZ758K7D08jn8XFUH3yVMDarfboff6OrNZz1qiAS5ud1QqLrAvEA',
        resetPassToken: null,
        resetPassExpires: null,
        lastPasswordAttempt: null,
        passwordAttemptCount: 0,
        forceUserChangePassword: null,
        lastConnection: '2019-12-06T17:35:16.000Z',
        createdAt: '2019-12-06T15:36:31.000Z',
        updatedAt: '2019-12-06T17:35:16.000Z',
        deletedAt: null,
        version: 6,
      },
      {
        id: 2,
        firstName: 'Jhon',
        lastName: 'Doe',
        email: 'jdoe@kontigo.pe',
        username: 'jdoe',
        password: '$argon2i$v=19$m=4096,t=3,p=1$v+Mdw6V23dshl8AiEzrjzw$tQnyGjWgEqZyw7RJUZIdPreSF52smYtbu3ZISonGiMI',
        stateId: 1,
        token: null,
        lastLoginAccess: null,
        lastLogoutAccess: null,
        lastIpAddress: null,
        lastToken: null,
        resetPassToken: null,
        resetPassExpires: null,
        lastPasswordAttempt: null,
        passwordAttemptCount: null,
        forceUserChangePassword: null,
        lastConnection: null,
        createdAt: '2019-12-06T17:36:43.000Z',
        updatedAt: '2019-12-06T17:36:43.000Z',
        deletedAt: null,
        version: 0,
      },
    ],
  }]
})

mock.onPost(`${apiUrl}/admin/users/create`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: {
      stateId: 1,
      version: 0,
      id: 3,
      firstName: 'Miguel',
      lastName: 'Vega',
      email: 'mvegaplm@gmail.com',
      username: 'miguel.vegap',
      password: '$argon2i$v=19$m=4096,t=3,p=1$MqTVVBeyd6Xxo055p90ejg$dc22O649xbc2luzCWiYZEq8cCSLMWU36xmpP3DARpy4',
      updatedAt: '2019-12-06T17:41:01.501Z',
      createdAt: '2019-12-06T17:41:01.501Z',
    },
  }]
})

mock.onPut(`${apiUrl}/admin/users/1/update`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: null,
  }]
})

mock.onPut(`${apiUrl}/admin/users/1/disable`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: null,
  }]
})

mock.onPut(`${apiUrl}/admin/users/1/enable`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: null,
  }]
})

mock.onPost(`${apiUrl}/admin/modules/create`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: null,
  }]
})

mock.onPost(`${apiUrl}/admin/roles/assign`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: null,
  }]
})

mock.onPost(`${apiUrl}/admin/modules/assign`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: null,
  }]
})

mock.onGet(`${apiUrl}/crediplaza-convenios/list-request`).reply(function(config) {
  return [200, {
    message: 'OK',
    data: {
      count: 1,
      rows: [
        {
          codigoSolicitante: 'CPZ0000000150',
          id: 150,
          tipoProductoId: 2,
          empresaId: 3,
          checkUsoDatos: 1,
          monto: 950,
          plazo: 3,
          montoSoftia: null,
          cuotaSoftia: null,
          tceaSoftia: null,
          teaSoftia: null,
          plazoSoftia: null,
          urlCronogramaPagosSoftia: null,
          urlContratoSoftia: null,
          urlHojaResumenSoftia: null,
          numeroCuenta: '100258963147',
          numeroCuentaInter: '1125200147893315',
          vistaHTML: 'Fin',
          checkAceptaContrato: 1,
          token: 'eyg',
          pin: 1491,
          numVecesPin: 1,
          errorPin: null,
          bancoId: 5,
          solicitudPropuestaId: null,
          estadoId: 4,
          errorModelador: null,
          motivoRechazo: null,
          createdAt: '2019-12-13T21:19:04.000Z',
          updatedAt: '2019-12-13T21:19:04.000Z',
          deletedAt: null,
          version: 0,
          motivoRechazoId: null,
          Cliente: {
            nombreApellidoCompleto: 'Miguel Vega Palomino',
            id: 150,
            nombres: 'Miguel',
            apellidoPaterno: 'Vega',
            apellidoMaterno: 'Palomino',
            numDocumento: '74684743',
            email: 'miguelv.ter@kontigo.pe',
            numCelular: '996634147',
            operadorId: 1,
            fechaNacimiento: '1995-01-19',
            profesionId: 1,
            esPep: 'N',
            domicilioBuro: null,
            domicilio: null,
            referenciaDomicilio: null,
            fechaInicioLabores: null,
            telefonoEmpresa: null,
            anexo: null,
            tipoIngreso: null,
            ingresoBruto1: '750',
            ingresoBruto2: null,
            ingresoBruto3: null,
            departamentoId: null,
            provinciaId: null,
            distritoId: null,
            createdAt: '2019-12-13T21:18:35.000Z',
            updatedAt: '2019-12-13T21:18:35.000Z',
            deletedAt: null,
            version: 0,
          },
          Estado: {
            id: 4,
            nombre: 'SOLICITADO',
            descripcion: '',
          },
          Banco: {
            id: 5,
            nombre: 'INTERBANK',
            abreviatura: 'INTERBANK',
          },
        },
      ],
      pagination: {
        limit: 5,
        offset: 0,
      },
    },
  }]
})
*/
injector.constant('axiosPure', axiosPureInstance)
injector.constant('axios', axiosInstance)
injector.constant('menu', menu)
